import styled from 'styled-components'

export const GroupingHeaderIconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 16px;

  div {
    display: flex;
    align-items: center;
    cursor: pointer;
    opacity: 1;
    transition: all 0.2s ease-in-out;
    width: 16px;
    height: 16px;
  }

  .hover {
    opacity: 0.6;
  }

  :hover {
    .hover {
      opacity: 1;
    }
    .placeholder {
      opacity: 0;
    }
  }
`
